// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__c3O71","hidden":"style_hidden__7VWRn","desktop_header":"style_desktop_header__GC_n_"};